// extracted by mini-css-extract-plugin
export default {"root":"_0Qw8dsiF8lWeQV0i5Bq","dates":"U4h_Ib1q5kv_G88KOFU0","placeHolderShimmer":"CIIj0rdTLSuTO8M0TTKK"};